export default __webpack_public_path__ + "static/media/environment_supporter.46f990b8.png";